const { default: axios } = require("axios");
import chatClass from './chat';

const Opportunity = function () {

    const cardLoad = function () {
        $('.cardLoad').each(function () {
            let el = $(this);
            let url = el.data('url');

            axios.get(url)
                .then(function (response) {
                    let data = response.data;
                    if (data.error === false) {
                        
                        let result = data.result;
                        el.find('.card-body').html(result.html);

                        if ($('#kt_chat_content').length > 0) {
                            chat();
                            $('.select2').select2();
                        }
                        
                    }
                    
                })
                .catch(function (error) {
                    el.find('.card-body').html('<div class="text-muted text-center p-20" title="'+error+'"><i class="fas fa-exclamation-circle"></i>Falha ao carregar</div>');
                });
        });
    }

    const chat = function(){
        $('#loading-div').fadeToggle(200).css('display', 'flex');
        KTLayoutChat.setup(KTUtil.getById('kt_chat_content'));
        enterChannel($('#kt_chat_content').data('room'));   

        chatClass.callbackChat();

        $('.scroll').animate({
			scrollTop: $('.messages-chat-whats').height()
		}, 1000);
    }

    const enterChannel = function (roomName) {
		Echo.leave(roomName);
		Echo.private(roomName)
        .listen('ChatMessage', (response) => {
            var messageElement = 0;
            if(response.transaction_code != undefined && response.transaction_code != null){
                var transaction_code = response.transaction_code;
                messageElement = $("#"+transaction_code).length;
            }
            
            if((typeof transaction_code === 'undefined') || messageElement == 0){
                const url = $(document).find('#kt_chat_content .messages').data('format');
                axios.post(url, response.chatMessage)
                    .then(function (response) {
                        const data = response.data;
                        const result = data.result;

                        if (data.error == false) {
                            let sectionMessages = $(document).find('#kt_chat_content .messages');

                            if (result.user_id == sectionMessages.data('user_id') && result.chat_channel_id == sectionMessages.data('chat_channel_id')) {
                                sectionMessages.append(result.html);

                                if(result.html_footer != undefined && $('#content').length == 0){
                                    $('#kt_chat_content .card-footer').replaceWith(result.html_footer);
                                }

                                $('.scroll').animate({
                                    scrollTop: $('#kt_chat_content .card-body .messages').height()
                                }, 100);

                                let context = new AudioContext();
                                if (context.state == "running") {
                                    document.getElementById('audio-notification').play()
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        const classUtilitites = new UtilitiesUP;
                        classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                        console.log(error);
                    });
            }else{
                const url = $(document).find('#kt_chat_content .messages').data('update-message');

                axios.post(url, response.chatMessage)
                    .then(function (response) {
                        const data = response.data;
                        const result = data.result;
                        

                        $(result.target).replaceWith(result.html);

                        $('.scroll').animate({
                            scrollTop: $('#kt_chat_content .card-body .messages').height()
                        }, 100);

                        // console.log(result);
                        if(result.error_json != undefined && result.error_json != ''){
                            if(result.error_json.action != undefined){
                                if (result.error_json.action ==="sendFlow") {
                                    const classUtilitites = new UtilitiesUP;
                                    classUtilitites.showAlert(result.error_json.translated_error, "Ok");
                                    location.reload();
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        // const classUtilitites = new UtilitiesUP;
                        // classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                        // console.log(error);
                    });
            }

        });
	}

    const select2Multi = () => {

        // multi select
        $('.select2-multi').each(function(){
            $(this).select2({
                placeholder: $(this).attr('data-placeholder'),
            })            
        })

    }

    const tabSearchDetail = (el) => {

        let elm         = el;
        let showContent = elm.attr('data-content');

        $('.tab-content-search').removeClass('active');
        $("#"+showContent).addClass('active');

    }

    return {
        init: function () {
            if ($('.cardLoad').length > 0) {
                cardLoad();
            }
            if($('.select2-multi').length > 0){
                select2Multi();
            }
            if($('.navi-col-link-change-search').length > 0){
                $(document).on('click', '.navi-col-link-change-search', function(){
                    tabSearchDetail($(this))
                });
            }
        }
    }

}();

export default Opportunity;